<script setup lang="ts" name="PublicUserCargoTrackerNoData">
import VCard from '~/components/VCard.vue';
import VCardState from '~/components/VCardState.vue';
import VCardText from '~/components/VCardText.vue';
import VesselMap from '~/components/VesselMap.vue';

const { serviceState } = defineProps<{
  serviceState: Record<string, unknown>;
}>();
</script>

<template>
  <div class="space-y-2">
    <VCard>
      <template #heading>
        <VCardText
          class="m-6"
          text="Bill of Lading Information"
          color="text-charcoal-6"
          size="text-subtitle-1"
        />
      </template>
    </VCard>

    <div class="grid grid-rows-2 gap-2 sm:grid-cols-2 sm:grid-rows-1">
      <VCardState
        title="Ports & Dates"
        titleColor="text-charcoal-6"
        stateTitleColor="card-text-charcoal-6"
        illustration="no-data"
        stateTitle="This Is Where You’ll See Information On Ports & Dates"
        stateMessage="Start by entering the bill of lading number"
      />

      <VCardState title="Vessel Location" titleColor="text-charcoal-6">
        <div class="h-[350px] w-full">
          <VesselMap :serviceState="serviceState" />
        </div>
      </VCardState>
    </div>

    <VCardState
      title="Port Agents"
      titleColor="text-charcoal-6"
      stateTitleColor="card-text-charcoal-6"
      illustration="man_on_ship"
      stateTitle="This Is Where You’ll See Information On Port Agents"
      stateMessage="Start by entering the bill of lading number"
      height="300"
    />
  </div>
</template>
